import React from 'react'

import Separator from '../../../../../../components/pdf/Separator'
import Text from '../../../../../../components/pdf/Text'
import Link from '../../../../../../components/pdf/Link'
import Line from '../../../../../../components/pdf/Line'

const TeamSection = ({ clientName, deploymentClientTeamReplies, financialClientTeamReplies }) => {
  return (
    <div id="equipe-projeto">
      <Text semibold size="h3">
        🤝 Equipe do Projeto
      </Text>
      <Line />
      <Separator weight={5} />
      <div id="equipe-projeto-1">
        <Text semibold size="h4">
          Ponto Focal da Btime
        </Text>
        <Separator weight={3} />
        <ul style={{ margin: '8px 0 14px', paddingLeft: '20px' }}>
          <li>
            <Text>
              <b>Nome:</b> Thainá Matos
            </Text>
          </li>
          <Separator weight={1} />
          <li>
            <Text style={{ display: 'flex', gap: 5 }}>
              <b>WhatsApp:</b> <Link href="https://wa.me/5511916867292">+55 (11) 91686-7292</Link>
            </Text>
          </li>
          <Separator weight={1} />
          <li>
            <Text style={{ display: 'flex', gap: 5 }}>
              <b>Email:</b> <Link href="mailto:suporte@btime.com.br">suporte@btime.com.br</Link>
            </Text>
          </li>
          <Separator weight={1} />
        </ul>
      </div>

      <Separator weight={5} />
      <div id="equipe-projeto-2">
        <Text semibold size="h4">
          Ponto Focal - {clientName}
        </Text>
        <Separator weight={3} />
        <ul style={{ margin: '8px 0 14px', paddingLeft: '20px' }}>
          {deploymentClientTeamReplies.map(reply => {
            return (
              <>
                <li>
                  <Text>
                    <b>Nome: </b> {reply.name}
                  </Text>
                </li>
                <Separator weight={1} />
                <li>
                  <Text style={{ display: 'flex', gap: 5 }}>
                    <b>Telefone/WhatsApp:</b> <Link href={`https://wa.me/55${reply.phone}`}>{reply.phone}</Link>
                  </Text>
                </li>
                <Separator weight={1} />
                <li>
                  <Text style={{ display: 'flex', gap: 5 }}>
                    <b>Email:</b> <Link href={`mailto:${reply.email}`}>{reply.email}</Link>
                  </Text>
                </li>
                <Separator weight={1} />
              </>
            )
          })}
        </ul>
      </div>

      <Separator weight={5} />

      <div id="equipe-projeto-3">
        <Text semibold size="h4">
          Contato Financeiro - {clientName}
        </Text>
        <Separator weight={3} />
        <ul style={{ margin: '8px 0 14px', paddingLeft: '20px' }}>
          {financialClientTeamReplies.map(reply => {
            return (
              <>
                <li>
                  <Text>
                    <b>Nome: </b> {reply.name}
                  </Text>
                </li>
                <Separator weight={1} />
                <li>
                  <Text style={{ display: 'flex', gap: 5 }}>
                    <b>Telefone/WhatsApp:</b> <Link href={`https://wa.me/55${reply.phone}`}>{reply.phone}</Link>
                  </Text>
                </li>
                <Separator weight={1} />
                <li>
                  <Text style={{ display: 'flex', gap: 5 }}>
                    <b>Email:</b> <Link href={`mailto:${reply.email}`}>{reply.email}</Link>
                  </Text>
                </li>
                <Separator weight={1} />
              </>
            )
          })}
        </ul>
      </div>

      <Separator weight={15} />
    </div>
  )
}

export default TeamSection
